import { InjectionToken } from '@angular/core';

/** Optional tuning for {@link ErrorInterceptor} per consuming app. */
export interface HttpErrorHandlingConfig {
  /**
   * When true, HTTP 403 does not navigate away to `/unauthorized`.
   * Callers receive {@link ApiError} so they can show inline/toast messages.
   */
  suppress403Redirect?: boolean;
}

export const HTTP_ERROR_HANDLING_CONFIG = new InjectionToken<HttpErrorHandlingConfig>('HTTP_ERROR_HANDLING_CONFIG');
